/**
 * Constantes de paginación del portafolio (`commercial_panel/portfolio`).
 *
 * El backend acota `page_size` a un máximo de 100 (ver `PortfolioValidation`).
 * Las vistas de Vigencias (server-side) y Asignaciones (client-side sobre el
 * conjunto completo) comparten estas opciones para sincronizar el selector.
 */

/** Tamaño de página por defecto al abrir una vista. */
export const DEFAULT_PAGE_SIZE = 20;

/** Opciones del selector "Mostrar N por página". */
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

/**
 * Tamaño de página que usa la carga completa de Asignaciones para acumular
 * páginas (es el tope permitido por el backend). Minimiza el nº de requests.
 */
export const FULL_LOAD_PAGE_SIZE = 100;
